import {computerToHumanIndexing} from '~/utils';

export function paginationParams(offset: number, pageSize: number) {
	return {
		per_page: pageSize,
		page: computerToHumanIndexing(Math.floor(offset / pageSize)),
	};
}
